export const TENANT_LABELS = {
  soc: 'Sport & Casino',
  tur: 'Tur'
};
export const TENANT_IDS = {
  MB: 'mb',
  SOC: 'soc',
  TUR: 'tur'
};
export const SELL_TYPE_IDS = {
  SPEL_LOTT: 1,
  SPEL: 2,
  LOTT: 3
};